import styled from 'styled-components';
import { Row as AntRow, Tag } from 'antd';
import {
  FormItem as FormItemBase,
  Text as OriginalText,
  Button as BaseButton,
} from '@vette/ui-components';
import { Typography as AntdTypography } from 'antd';

export const StripeTitleBox = styled.div`
  display: flex;
  align-items: center;
`;

export const Image = styled.img`
  width: 48px;
  height: 48px;
  margin-right: 12px;
`;

export const Content = styled.div`
  width: 500px;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 36px;
`;

export const Section = styled.div`
  display: flex;
  flex: 1;
  gap: 12px;
  flex-direction: column;
  margin-bottom: 30px;

  &:nth-child(3) {
    margin-bottom: 18px;
  }
`;

export const TitleRow = styled(AntRow)`
  margin-bottom: 20px;
`;

export const StatBadge = styled(Tag)`
  color: ${({ theme }) => theme.colors.white};
  height: max-content;
  border: none;
  background: ${({ theme }) => theme.colors.green40};
  padding: 1px 8px;
  font-weight: 600;
  margin: 0;
`;

export const FullWidthFormItem = styled(FormItemBase)`
  width: 100%;
`;

export const DisclaimerText = styled(OriginalText)`
  color: ${({ theme }) => theme.colors.grey40};
  display: block;
  text-align: left;
`;

export const DisclaimerTypography = styled(AntdTypography)`
  text-align: center;
  margin-top: 12px;
`;

export const Button = styled(BaseButton)`
  margin: 10px 0px;
`;

export const DisclaimerButton = styled(BaseButton)`
  color: ${({ theme }) => theme.colors.grey40};
  display: inline;
  font-size: inherit;
  height: auto;
  padding: inherit;
  line-height: inherit;
  font-weight: inherit;

  &.ant-btn > span {
    color: ${({ theme }) => theme.colors.grey40};
    text-decoration: underline;
  }
`;
